import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import { PublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

loadFonts();

const msalApp = new PublicClientApplication({
  auth: {
    clientId: process.env.VUE_APP_CLID,
    authority: "https://login.microsoftonline.com/706c5db9-5278-483b-b622-70084f823a12/",
    postLogoutRedirectUri: window.location.origin,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
    secureCookies: true,
  },
});

await msalApp.initialize();
window.msalApp = msalApp;

async function getAccessToken() {
  msalApp.handleRedirectPromise();
  return msalApp
    .acquireTokenSilent({
      scopes: [`api://${process.env.VUE_APP_CLID}/login`, "User.Read"],
    })
    .then((accessTokenResponse) => {
      return `Bearer ${accessTokenResponse.accessToken}`;
    })
    .catch((error) => {
      if (error instanceof InteractionRequiredAuthError) {
        msalApp
          .loginRedirect({
            scopes: [`api://${process.env.VUE_APP_CLID}/login`, "User.Read"],
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    });
    
}

export async function getUserPhoto() {
  var response;
  var accessToken;
  if (await getAccessToken()) {
    response = await msalApp.acquireTokenSilent({
      scopes: ["User.Read"],
    });
    accessToken = response.accessToken;
  }
  const photoResponse = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (photoResponse.ok) {
    var photoData = await photoResponse.blob();
    photoData = URL.createObjectURL(photoData);
    return photoData;
  } else {
    photoData = null;
    return photoData;
  }
}

if (process.env.VUE_APP_BACKEND != undefined) {
  axios.defaults.baseURL = process.env.VUE_APP_BACKEND;
} else {
  axios.defaults.baseURL = "https://hplv0-staging.azurewebsites.net/";
}

// axios.defaults.baseURL = "https://hplv0.azurewebsites.net";

axios.interceptors.request.use(async (config) => {
  const accessToken = await getAccessToken();
  config.headers.Authorization = accessToken;
  return config;
});


const app = createApp(App).use(router);
app.config.globalProperties.$http = axios;

// app.use(store);
app.use(router);
app.use(vuetify);
app.mount("#app");
